import { Component } from 'react';
/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
export default class TreeNode extends Component {
}
TreeNode.__PRO_TREE_SELECT_NODE = true;
